import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ViewEncapsulation } from "@angular/core";
import { CclDrawerService, CclBuilderService, CclMessageService, CclNavbarFooterService, CclRouteTab } from "certain-common-library";

import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Subscription } from "rxjs";
import { cloneDeep } from "lodash";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { LocalDataService } from "../../../../../modules/shared/services/local-data.service";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: "app-session-page",
    templateUrl: "./session-page.view.html",
    styleUrls: [],
    encapsulation: ViewEncapsulation.None
})
export class SessionPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit, OnDestroy {
    subscription: Subscription;
    sessionConfigObj: any;
    baseUrl = "";
    sessionConfig: any = {};
    basedOnImageName: any = {};
    ddfJson = "session-ddf.json";
    headerLayout: string;
    bodyLayout: string;
    fontstyle: any = {};
    generalfontStyle: any = {};
    ddfData: Array<any> = [];
    hover = false;
    selectedTab: string = 'public';
    templateStyles: any = {
        l_circular: "Layout w/ Circular Image",
        l_noimage: "Layout without Image",
        l_square: "Layout w/ Square Image",
        l_banner: "Layout w/ Banner Image"
    };
    sessionTemplateType: string;
    headerThumbnailHtml;
    bodyThumbnailHtml;
    constructor(
        public sharedService: SharedService,
        private drawerService: CclDrawerService,
        public builderService: CclBuilderService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private activatedRoute: ActivatedRoute,
        private catalogService: CatalogService,
        private localDataService: LocalDataService,
        private sanitizer: DomSanitizer
    ) {
        super(sharedService);
        if (this.activatedRoute.routeConfig.path === "highlighted-session") {
            this.baseUrl = "highlighted";
            this.ddfJson = "session-without-instance-ddf.json";
        } else if (this.activatedRoute.routeConfig.path === "promoted-session") {
            this.baseUrl = "promoted";
            this.ddfJson = "session-without-instance-ddf.json";
        } else if (this.activatedRoute.routeConfig.path === "general-session") {
            this.baseUrl = "general";
            this.ddfJson = "session-ddf.json";
        }
        this.sessionTemplateType = sharedService.catalogLayoutConfig;

        sharedService.sessionUrl = this.baseUrl;
        this.localDataService.getJSON(this.ddfJson).subscribe((data) => {
            if (data != null) {
                this.ddfData = data;
            }

            if (this.sharedService.sessionCustomFields != null) {
                this.sharedService.sessionCustomFields.forEach((cf) => {
                    this.ddfData.push({
                        label: cf.name,
                        key: "{@ddf.customFieldMap." + cf.code.replace(/ /g, "") + "@}",
                        type: "Session custom field"
                    });
                });
            }

            this.headerLayout = this.getFormattedDDFData("header");
            this.bodyLayout = this.getFormattedDDFData("body");
        });
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveSessionConfig(message));
    }

    getFormattedDDFData(expansionStyle) {
        let contentString = ''
        if(expansionStyle == 'header') {
            contentString =  this.selectedTab === 'public' ? this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[expansionStyle]
            .textConfig.template : this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[expansionStyle]
            .textConfig.privateTemplate;
        } else if (expansionStyle == 'body') {
            contentString =  this.selectedTab === 'public' ? this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[expansionStyle]
            .textConfig.template : this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[expansionStyle]
            .textConfig.privateTemplate;
        }
        if (contentString != null) {
            this.ddfData.forEach(function(value, key) {
                if (contentString.indexOf(value.key) > -1) {
                    contentString = contentString.replace(new RegExp(value.key, "g"), value.label);
                }
            });
            return contentString
                .replace(new RegExp('contenteditable="true"', "g"), "")
                .replace(new RegExp("contenteditable='true'", "g"), "");
        } else {
            return "";
        }
    }
    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.sharedService.currentLayoutSection = this.baseUrl + "-session";
        this.sessionConfigObj = this.sharedService.configs[this.sharedService.configTypes.SESSION[this.baseUrl]];
        this.sessionConfigObj.config = JSON.parse(this.sessionConfigObj.config)
        if(this.baseUrl == "highlighted" || this.baseUrl == "promoted") {
            if(!('privateTemplate' in this.sessionConfigObj.config.catalogConfig['header'].textConfig)) {
                this.sessionConfigObj.config.catalogConfig['header'].textConfig.privateTemplate = this.sharedService.highlightedOrPromotedTemplate
            }
            
            if(!('privateTemplate' in this.sessionConfigObj.config.catalogConfig['body'].textConfig)) {
                this.sessionConfigObj.config.catalogConfig['body'].textConfig.privateTemplate = this.sharedService.expandHighlightedOrPromotedTemplate
            }
        } 
        
        if(this.baseUrl == 'general') {
            if(!('privateTemplate' in this.sessionConfigObj.config.catalogConfig['header'].textConfig)) {
                this.sessionConfigObj.config.catalogConfig['header'].textConfig.privateTemplate = this.sharedService.generalSessionTemplate
            } 
            
            if(!('privateTemplate' in this.sessionConfigObj.config.catalogConfig['body'].textConfig)) {
                this.sessionConfigObj.config.catalogConfig['body'].textConfig.privateTemplate = this.sharedService.expandGeneralSessionTemplate
            }
        }

        this.sessionConfigObj.config = JSON.stringify(this.sessionConfigObj.config)
        
        if (this.sessionConfigObj == null || this.sessionConfigObj.id == null) {
            this.sessionConfig = cloneDeep(this.sharedService.sessionLayoutConfig[this.baseUrl]);
            this.sessionConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.SESSION[this.baseUrl]
            };
        } else {
            this.sessionConfig = JSON.parse(this.sessionConfigObj.config);
            this.sharedService.sessionLayoutConfig[this.baseUrl] = cloneDeep(this.sessionConfig);
        }
        if(!this.sessionConfig.catalogConfig['header'].imageConfig.dynamicImage) {
            this.sessionConfig.catalogConfig['header'].imageConfig.dynamicImage = 'assets/images/upload-image.png'
        }

        if(!this.sessionConfig.catalogConfig['body'].imageConfig.dynamicImage) {
            this.sessionConfig.catalogConfig['body'].imageConfig.dynamicImage = 'assets/images/upload-image.png'
        }

        if(!this.sessionConfig.catalogConfig.hasOwnProperty("showSearchBar")) {
            this.sessionConfig.catalogConfig.showSearchBar = true;
        }

        if(!this.sessionConfig.catalogConfig.hasOwnProperty("searchBarText")) {
            this.sessionConfig.catalogConfig.searchBarText = 'Enter a Search term to find Sessions...';
        }

        if (!this.sessionConfig.catalogConfig.body.assetConfig) {
            this.sessionConfig.catalogConfig.body.assetConfig = this.sharedService.assetConfig;
        } 

        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.sessionConfig);
        this.sharedService.changedData = this.sessionConfig;

        this.fontstyle = {
            "color": this.sessionConfig.labelConfig.fontColor,
            "font-style": this.sessionConfig.labelConfig.fontStyle,
            "text-decoration": this.sessionConfig.labelConfig.fontStyle,
            "font-weight": this.sessionConfig.labelConfig.fontStyle,
            "font-size": this.sessionConfig.labelConfig.fontSize + "px",
            "padding-right": "5px"
        };
        this.generalfontStyle = {
            "color": "#737373",
            "font-style": "normal",
            "text-decoration": "normal",
            "font-weight": "normal",
            "font-size": "16px",
            "padding-right": "5px"
        };
        // for backward compatibility
        if (this.baseUrl == "general" && this.sessionConfig.catalogConfig.buttonConfig == null) {
            this.sessionConfig.catalogConfig.buttonConfig = this.sharedService.sessionLayoutConfig[
                this.baseUrl
            ].catalogConfig.buttonConfig;
        }

        this.setBasedOnImageNameHelper("header");
        this.setBasedOnImageNameHelper("body");
    }

    private setBasedOnImageNameHelper(property) {
        if (this.sessionConfig.catalogConfig[property].imageConfig.basedOn == "speaker_img") {
            this.basedOnImageName[property] = "Speaker <br/> Profile <br/> Image";
            if (this.sessionConfig.layout == "l_banner") {
                this.sessionConfig.catalogConfig[property].imageConfig.basedOn = 'dynamic_img'
            }
        } else if (this.sessionConfig.catalogConfig[property].imageConfig.basedOn == "dynamic_img") {
                var img = this.sessionConfig.catalogConfig[property].imageConfig.dynamicImage;
                var filename = img ? img.replace(/^.*[\\\/]/, "") : "";
                var encodeFileName = filename ? encodeURIComponent(filename) : "";
                var imgURL = img ? img.replace(filename, encodeFileName) : "";
                var imgHeight = this.sessionConfig.catalogConfig[property].imageConfig.height;
                var imgWidth = this.sessionConfig.catalogConfig[property].imageConfig.width;
            // }
            if (this.sessionConfig.layout == "l_circular") {
                this.basedOnImageName[property] =
                    "<img alt='Dynamic image uploaded' class='img-border-radius' height=" +
                    imgHeight +
                    " width=" +
                    imgWidth +
                    " src=" +
                    imgURL +
                    ">";
            } else if (this.sessionConfig.layout == "l_square") {
                this.basedOnImageName[property] =
                    "<img alt='Dynamic image uploaded' height=" +
                    imgHeight +
                    " width=" +
                    imgWidth +
                    " src=" +
                    imgURL +
                    ">";
            }
        } else if(this.sessionConfig.catalogConfig[property].imageConfig.basedOn == "thumbnail_img") {
            var img = this.sessionConfig.catalogConfig[property].imageConfig.dynamicImage;
                var filename = img ? img.replace(/^.*[\\\/]/, "") : "";
                var encodeFileName = filename ? encodeURIComponent(filename) : "";
                var imgURL = img ? img.replace(filename, encodeFileName) : "";
                var imgHeight = this.sessionConfig.catalogConfig[property].imageConfig.height;
                var imgWidth = this.sessionConfig.catalogConfig[property].imageConfig.width;
            if(this.sessionConfig.layout == "l_circular") {
                this.sessionConfig.catalogConfig[property].imageConfig.basedOn = "dynamic_img"
                this.basedOnImageName[property] =
                    "<img alt='Dynamic image uploaded' class='img-border-radius' height=" +
                    imgHeight +
                    " width=" +
                    imgWidth +
                    " src=" +
                    imgURL +
                    ">";
            }

            if(this.sessionConfig.layout == "l_square") {
                this.sessionConfig.catalogConfig[property].imageConfig.basedOn = "dynamic_img"
                this.basedOnImageName[property] =
                "<img alt='Dynamic image uploaded' height=" +
                imgHeight +
                " width=" +
                imgWidth +
                " src=" +
                imgURL +
                ">";
            }


            if(this.sessionConfig.layout == 'l_banner') {
                if(property == 'header') {
                    this.headerThumbnailHtml = this.sessionConfig.catalogConfig[property].imageConfig.displayIcon ? this.sanitizer.bypassSecurityTrustHtml(this.sessionConfig.catalogConfig[property].imageConfig.displayIcon) : "";
                } else {
                    this.bodyThumbnailHtml = this.sessionConfig.catalogConfig[property].imageConfig.displayIcon ? this.sanitizer.bypassSecurityTrustHtml(this.sessionConfig.catalogConfig[property].imageConfig.displayIcon) : "" ;
                }

            }
        } else {
            if (this.sharedService.sessionFileCustomFields != null) {
                this.sharedService.sessionFileCustomFields.forEach((cf) => {
                    if ("custom_" + cf.code == this.sessionConfig.catalogConfig[property].imageConfig.basedOn) {
                        this.basedOnImageName[property] = cf.name;
                    }
                });
            }
        }
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            if (this.baseUrl === "highlighted") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define Promoted Sessions";
            } else if (this.baseUrl === "promoted") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define General Sessions";
            } else {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define HTML";
            }
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-session";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-session";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    saveSessionConfig(message) {
        if (message.text == "save-session" || message.text == "save-next-session") {
            this.sessionConfigObj.config = JSON.stringify(this.sessionConfig);
            this.catalogService.saveSetupConfig(this.sessionConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.createCss(this.catalogService);
                this.sharedService.originalData = cloneDeep(this.sessionConfig);
                this.sharedService.changedData = this.sessionConfig;

                this.sessionConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                if(this.sharedService.setup.setupConfigs && this.sharedService.setup.setupConfigs.length>0) {
                    let index = this.sharedService.setup.setupConfigs.findIndex(elem => elem.id === this.sessionConfigObj.id);
                    this.sharedService.setup.setupConfigs[index] = this.sessionConfigObj
                }
                this.sharedService.configs[
                    this.sharedService.configTypes.SESSION[this.baseUrl]
                ] = this.sessionConfigObj;
                this._flashMessagesService.show(
                    this.sharedService.toCamelCase(this.baseUrl) + " Session layout saved successfully.",
                    {
                        cssClass: "alert-success"
                    }
                );
                if (message.text == "save-next-session") {
                    if (this.activatedRoute.routeConfig.path === "highlighted-session") {
                        this.sharedService.currentLayoutSection = "promoted-session";
                        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/promoted-session");
                    } else if (this.activatedRoute.routeConfig.path === "promoted-session") {
                        this.sharedService.currentLayoutSection = "general-session";
                        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/general-session");
                    } else if (this.activatedRoute.routeConfig.path === "general-session") {
                        this.sharedService.currentLayoutSection = "html-bottom";
                        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/html-bottom");
                    }
                }
            });
        } else if (message.text == "apply-session-config") {
            if(!this.sharedService.isMSIE()) {
            window.dispatchEvent(new Event("resize"));
            }
            
            if(this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.hasOwnProperty('assetConfig') && this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.firstGroupList.length>0) {
                let AssetList =  this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.firstGroupList;
                this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.documentTemplate = "<div [hidden]=\"checkIfDDFExist('first-group','{@ddf.id@}')\">" +
                `<span class="${this.baseUrl}-session-group-header"> <strong> ${this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.firstGroupLabel}: </strong> </span>
                <br><div>
                <ul class="asset-list first-group-{@ddf.id@}">`
                for(let i=0; i<AssetList.length; i++) {
                    let str;
                    if(AssetList[i].value == '{@ddf.presentations@}') {
                        str = AssetList[i].value.replace(/@/g, "*");
                    } else if (AssetList[i].value == '{@ddf.abstractFile@}') {
                        str = AssetList[i].value.replace(/@/g, "*");
                    } else if (AssetList[i].type == 'text_url') {
                        str = "<li *ngIf= \"'" + AssetList[i].value.replace(/@/g, "#") + "'\" class=\"" + this.baseUrl + "-session-asset-row\"> " +
                    `<span class="${this.baseUrl}-session-document-label pull-left"> ${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)} </span> <span class="pull-right"> <button title="View" class="${this.baseUrl}-session-download-btn" type="button"` +
                        "(cclClick)=\"viewSessionDocument($event, '" + AssetList[i].value.replace(/@/g, "#") + "')\"> View  </button> </span> </li>";
                    } else {
                        str = "<li *ngIf= \"'" + AssetList[i].value.replace(/@/g, "#") + "'\" class=\"" + this.baseUrl + "-session-asset-row\"> " +
                    `<span class="${this.baseUrl}-session-document-label pull-left"> ${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)} </span> <span class="pull-right"> <button title="Download" class="${this.baseUrl}-session-download-btn" type="button"` +
                        "(cclClick)=\"downloadSessionDocument($event,'{@ddf.eventId@}', '" + AssetList[i].value.replace(/@/g, "#") + "', 'Custom','{@ddf.sessionId@}')\"> Download  </button> </span> </li>";
                    }
                    this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.documentTemplate = this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.documentTemplate + str;
                }
                this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.documentTemplate = this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.documentTemplate + '</ul></div></div>';
            } else {
                this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.documentTemplate = '';
            }
            if(this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.hasOwnProperty('assetConfig') && this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.secondGroupList.length>0) {
                let AssetList =  this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.secondGroupList;
                this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.videoTemplate = "<div [hidden]=\"checkIfDDFExist('second-group','{@ddf.id@}')\">" +
                `<span class="${this.baseUrl}-session-group-header"> <strong> ${this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.secondGroupLabel}: </strong> </span>
                <br><div>
                <ul class="asset-list second-group-{@ddf.id@}">`
                for(let i=0; i<AssetList.length; i++) {
                    let str;
                    if(AssetList[i].value == '{@ddf.presentations@}') {
                        str = AssetList[i].value.replace(/@/g, "*");
                    } else if (AssetList[i].value == '{@ddf.abstractFile@}') {
                        str = AssetList[i].value.replace(/@/g, "*");
                    } else if (AssetList[i].type == 'text_url') {
                        str = "<li *ngIf= \"'" + AssetList[i].value.replace(/@/g, "#") + "'\" class=\"" + this.baseUrl + "-session-asset-row\"> " +
                    `<span class="${this.baseUrl}-session-document-label pull-left"> ${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)} </span> <span class="pull-right"> <button title="View" class="${this.baseUrl}-session-download-btn" type="button"` +
                        "(cclClick)=\"viewSessionDocument($event, '" + AssetList[i].value.replace(/@/g, "#") + "')\"> View  </button> </span> </li>";
                    } else {
                        str = "<li *ngIf= \"'" + AssetList[i].value.replace(/@/g, "#") + "'\" class=\"" + this.baseUrl + "-session-asset-row\"> " +
                    `<span class="${this.baseUrl}-session-document-label pull-left"> ${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)} </span> <span class="pull-right"> <button title="Download" class="${this.baseUrl}-session-download-btn" type="button"` +
                        "(cclClick)=\"downloadSessionDocument($event,'{@ddf.eventId@}', '" + AssetList[i].value.replace(/@/g, "#") + "', 'Custom','{@ddf.sessionId@}')\"> Download  </button> </span> </li>";
                    }
                    this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.videoTemplate = this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.videoTemplate + str;
                }
                this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.videoTemplate = this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.videoTemplate + '</ul></div></div>';
            } else {
                this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.videoTemplate = '';
            }

            if(this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.hasOwnProperty('assetConfig') && this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.thirdGroupList.length>0) {
                let AssetList =  this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.thirdGroupList;
                this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.thirdTemplate = "<div [hidden]=\"checkIfDDFExist('third-group','{@ddf.id@}')\">" +
                `<span class="${this.baseUrl}-session-group-header"> <strong> ${this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.thirdGroupLabel}: </strong> </span>
                <br><div>
                <ul class="asset-list third-group-{@ddf.id@}">`
                for(let i=0; i<AssetList.length; i++) {
                    let str;
                    if(AssetList[i].value == '{@ddf.presentations@}') {
                        str = AssetList[i].value.replace(/@/g, "*");
                    } else if (AssetList[i].value == '{@ddf.abstractFile@}') {
                        str = AssetList[i].value.replace(/@/g, "*");
                    } else if (AssetList[i].type == 'text_url') {
                        str = "<li *ngIf= \"'" + AssetList[i].value.replace(/@/g, "#") + "'\" class=\"" + this.baseUrl + "-session-asset-row\"> " +
                    `<span class="${this.baseUrl}-session-document-label pull-left"> ${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)} </span> <span class="pull-right"> <button title="View" class="${this.baseUrl}-session-download-btn" type="button"` +
                        "(cclClick)=\"viewSessionDocument($event, '" + AssetList[i].value.replace(/@/g, "#") + "')\"> View  </button> </span> </li>";
                    } else {
                        str = "<li *ngIf= \"'" + AssetList[i].value.replace(/@/g, "#") + "'\" class=\"" + this.baseUrl + "-session-asset-row\"> " +
                    `<span class="${this.baseUrl}-session-document-label pull-left"> ${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)} </span> <span class="pull-right"> <button title="Download" class="${this.baseUrl}-session-download-btn" type="button"` +
                        "(cclClick)=\"downloadSessionDocument($event,'{@ddf.eventId@}', '" + AssetList[i].value.replace(/@/g, "#") + "', 'Custom','{@ddf.sessionId@}')\"> Download  </button> </span> </li>";
                    }
                    this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.thirdTemplate = this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.thirdTemplate + str;
                }
                this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.thirdTemplate = this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.thirdTemplate + '</ul></div></div>';
            } else {
                this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig.body.assetConfig.thirdTemplate = '';
            }
            this.sessionConfig = cloneDeep(this.sharedService.sessionLayoutConfig[this.baseUrl]);
            // For checking unsaved data
            this.sharedService.changedData = this.sessionConfig;

            this.drawerService.hideDrawer();

            this.setBasedOnImageNameHelper("header");
            this.setBasedOnImageNameHelper("body");

            this.fontstyle = {};
            setTimeout(() => {
                this.fontstyle = {
                    color: this.sessionConfig.labelConfig.fontColor,
                    "font-style": this.sessionConfig.labelConfig.fontStyle,
                    "text-decoration": this.sessionConfig.labelConfig.fontStyle,
                    "font-weight": this.sessionConfig.labelConfig.fontStyle,
                    "font-size": this.sessionConfig.labelConfig.fontSize + "px",
                    "padding-right": "5px"
                };
            }, 0);
            this.headerLayout = this.getFormattedDDFData("header");
            this.bodyLayout = this.getFormattedDDFData("body");
        }
    }

    openConfigDrawer(item, $event, expansionStyle) {
        $event.stopPropagation();
        let url = "";
        this.sharedService.sessionLayoutConfig[this.baseUrl] = cloneDeep(this.sessionConfig);
        this.sharedService.expansionStyle = expansionStyle;
        if (item == "template") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Choose a different Template",
                navLinks: null,
                saveMessage: "apply-session-config"
            };
            url = "config-drawer/session/template-config";
        } else if (item == "img") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Dynamic Image",
                navLinks: null,
                saveMessage: "apply-session-config"
            };
            url = "config-drawer/session/image-config";
        } else if (item == "region") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Region",
                navLinks: null,
                saveMessage: "apply-session-config"
            };
            url = "config-drawer/session/region-config";
        } else if (item == "html") {
            this.drawerService.toggleDrawer("mid");
            this.sharedService.currentDrawer = {
                title: "Edit Text",
                navLinks: null,
                saveMessage: "apply-session-config"
            };
            if(expansionStyle === 'header') {
                url = this.selectedTab == 'public' ? "config-drawer/session/html-config" : "config-drawer/session/html-private-config";
            } else if (expansionStyle === 'body') {
                url = this.selectedTab == 'public' ? "config-drawer/session/html-config" : "config-drawer/session/html-private-config";
            }
        } else if (item == "label") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Label",
                navLinks: null,
                saveMessage: "apply-session-config"
            };
            url = "config-drawer/session/label-config";
        } else if(item == "searchText") {
            if(this.sessionConfig.catalogConfig.showSearchBar == true) {
                this.drawerService.toggleDrawer("small");
                this.sharedService.currentDrawer = {
                    title: "Edit Search Bar Placeholder",
                    navLinks: null,
                    saveMessage: "apply-session-config"
                };
                url = "config-drawer/session/label-config";
            } else {
                return false;
        }
        } else if(item == 'assets') {
            this.drawerService.toggleDrawer("mid");
            this.sharedService.currentDrawer = {
                title: "Edit Assets",
                navLinks: [
                    new CclRouteTab("Fields", "session/asset-config"),
                    new CclRouteTab("Display", "session/asset-display-config")
                ],
                saveMessage: "apply-session-config"
            };
            url = "config-drawer/session/asset-config";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }

    toggleHTMLEnable(e) {
        this.sessionConfig.catalogConfig.showSearchBar = !this.sessionConfig.catalogConfig.showSearchBar;
    }

    getActivatedRoute() {
        return this.activatedRoute;
    }

    selectTab(value, type) {
        this[type] = value;
        this.headerLayout = this.getFormattedDDFData("header");
        this.bodyLayout = this.getFormattedDDFData("body");
    }
}
